module.exports = __webpack_public_path__ + "img/P27-zh.a5d70d8a.png";